<!-- begin::Sticky Toolbar -->
<ul *ngIf='role_id!=2' class="kt-sticky-toolbar" style="margin-top: 30px;">
	<li  class="kt-sticky-toolbar__item kt-sticky-toolbar__item--success" id="kt_demo_panel_toggle" data-placement="left" ngbTooltip="Notifications"  (click)="notification()">
		<a href="javascript:;" class=""><i class="flaticon2-drop"></i></a>
	</li>
	<!-- <li class="kt-sticky-toolbar__item kt-sticky-toolbar__item--brand" data-placement="left" ngbTooltip="Layout Builder">
		<a href="javascript:;" routerLink="/builder"><i class="flaticon2-gear"></i></a>
	</li>
	<li class="kt-sticky-toolbar__item kt-sticky-toolbar__item--warning" data-placement="left" ngbTooltip="Documentation">
		<a href="https://keenthemes.com/metronic/?page=docs" target="_blank"><i class="flaticon2-telegram-logo"></i></a>
	</li> -->
	
</ul>
<!-- end::Sticky Toolbar -->

<!-- begin::Demo Panel -->
<div ktOffcanvas [options]="demoPanelOptions" id="kt_demo_panel" class="kt-demo-panel">
	<div class="kt-demo-panel__head">
		<h3 class="kt-demo-panel__title">
			Notifications
		</h3>
		<a href="javascript:;" class="kt-demo-panel__close" id="kt_demo_panel_close"><i class="flaticon2-delete"></i></a>
	</div>
	<!-- <div [perfectScrollbar]="{wheelPropagation: false}"
							
							class="kt-notification kt-margin-t-50 kt-margin-b-10"> -->
	<div class="kt-demo-panel__body kt-scroll">
		<div class="notification__item" *ngFor="let item of notifiy;  let i=index">
			<div  class="details col-lg-9">
				{{item.Description}} -  {{item.count}}
				<br> 
				<!-- <button (click)="redirectpage(item.status)" >Go To</button> -->
				<!-- <div class="kt-notification__item-icon">
					<i class="flaticon2-line-chart kt-font-success"></i>
				</div> -->
			
				
				<br>
			</div>
			<!-- <div class="time">
				{{item.count}} 
					
				</div> -->
				<div *ngIf="item.count != 0" class="col-lg-3"> 
					
				
					<button (click)="redirectpage(item.status)" >Go </button> 
				<br> 
				</div>
				<br>

		</div>
	</div>
	<!-- </div> -->
</div>
<!-- end::Demo Panel -->
